<div class="flex flex-col gap-5">

    <dl class="m-0 rounded-xl border border-border bg-card p-5 shadow-sm">

        <div class="flex gap-3.5 border-b border-border py-3.5 first:pt-0">
            <dt class="w-32 shrink-0 pt-0.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">Brief name
            </dt>
            <dd class="m-0 min-w-0 flex-1 text-[15px] leading-relaxed text-foreground">
                @if (briefName()) { {{ briefName() }} } @else {
                <span class="text-muted-foreground">Not named yet</span>
                }
            </dd>
        </div>

        <div class="flex gap-3.5 border-b border-border py-3.5">
            <dt class="w-32 shrink-0 pt-0.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">Product</dt>
            <dd class="m-0 min-w-0 flex-1 text-[15px] leading-relaxed text-foreground">
                @if (createScreeningService.selectedProduct(); as product) {
                <span class="flex items-center gap-2.5">
                    @if (product.productImage) {
                    <span class="block size-8 shrink-0 overflow-hidden rounded-md">
                        <atom-ldg-img inputClass="object-cover" w="full" radius="md"
                            [src]="imageService.getImageSource(product.productImage, 'gallery')"></atom-ldg-img>
                    </span>
                    }
                    {{ product.productName }}
                </span>
                } @else {
                <span class="text-muted-foreground">No product selected</span>
                }
            </dd>
        </div>

        <div class="flex gap-3.5 border-b border-border py-3.5">
            <dt class="w-32 shrink-0 pt-0.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">Looking for
            </dt>
            <dd class="m-0 min-w-0 flex-1 whitespace-pre-line text-[15px] leading-relaxed text-foreground">
                @if (createScreeningService.lookFor().trim()) { {{ createScreeningService.lookFor().trim() }} } @else {
                <span class="text-muted-foreground">Nothing described yet</span>
                }
            </dd>
        </div>

        <div class="flex gap-3.5 border-b border-border py-3.5">
            <dt class="w-32 shrink-0 pt-0.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">Red flags
            </dt>
            <dd class="m-0 min-w-0 flex-1 text-[15px] leading-relaxed text-foreground">
                @if (restrictionGroups().length) {
                <span class="flex flex-wrap gap-1.5">
                    @for (group of restrictionGroups(); track group.label) {
                    <span
                        class="rounded-full bg-brand-studio/10 px-2.5 py-1 text-xs font-semibold text-brand-studio-dark dark:text-brand-studio">{{
                        group.label }} · {{ group.count }}</span>
                    }
                </span>
                } @else {
                <span class="text-muted-foreground">No restrictions added</span>
                }
            </dd>
        </div>

        <div class="flex gap-3.5 py-3.5 last:pb-0">
            <dt class="w-32 shrink-0 pt-0.5 text-xs font-bold uppercase tracking-wide text-muted-foreground">Reporting
            </dt>
            <dd class="m-0 min-w-0 flex-1 text-[15px] leading-relaxed text-foreground">
                @switch (createScreeningService.reportType()) {
                @case ('standard') {
                <span
                    class="inline-block rounded-full bg-brand-studio/10 px-2.5 py-1 text-xs font-semibold text-brand-studio-dark dark:text-brand-studio">Standard
                    report</span>
                }
                @case ('custom') {
                <span
                    class="mb-2 inline-block rounded-full bg-brand-studio/10 px-2.5 py-1 text-xs font-semibold text-brand-studio-dark dark:text-brand-studio">Custom
                    analysis</span>
                @if (createScreeningService.reportPrompt().trim()) {
                <span class="block whitespace-pre-line">{{ createScreeningService.reportPrompt().trim() }}</span>
                } @else {
                <span class="block text-muted-foreground">No reporting instructions written yet</span>
                }
                }
                @default {
                <span class="text-muted-foreground">No reporting type chosen</span>
                }
                }
            </dd>
        </div>
    </dl>

    <!-- how far back to screen — required by the API, no step of its own in the design -->
    <div class="rounded-xl border border-border bg-card p-5 shadow-sm">
        <sbs-screening-window />
    </div>

    <p class="m-0 flex items-center gap-3 rounded-xl border border-border bg-muted px-4 py-3.5 text-[13px] text-muted-foreground">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="shrink-0" aria-hidden="true">
            <rect width="20" height="8" x="2" y="2" rx="2" ry="2" />
            <rect width="20" height="8" x="2" y="14" rx="2" ry="2" />
            <line x1="6" x2="6.01" y1="6" y2="6" />
            <line x1="6" x2="6.01" y1="18" y2="18" />
        </svg>
        We'll run a quick server-side check to confirm your brief has clear requirements and restrictions before you add
        creators.
    </p>
</div>
